
import { FormsAndSurveyServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      deletedSurveys: [],
      restoreInProgress: false,
      loadingSurveys: false,
      selected: [] as Array<{_id:string,name:string}>,
      fields: [{key:'selected',label:'Selected',class:'text-center'}, {key:'_id',label:'ID'},{key:'name',label:'Name'}]
    };
  },
  methods: {
    onRowSelected(items:Array<{_id:string,name:string}>) {
      this.selected = items
    },
    selectAllRows() {
      (this.$refs.selectableTable as unknown as { selectAllRows:Function }).selectAllRows()
    },
    clearSelected() {
      (this.$refs.selectableTable as unknown as { clearSelected:Function }).clearSelected()
    },
    async fetchAllDeletedSurveys() {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.loadingSurveys = true;
        const { data } = await FormsAndSurveyServices.getDeletedSurveyByLocation({
          locationId: this.locationId
        });
        this.deletedSurveys = data.surveys;
        this.loadingSurveys = false;
      } catch (error) {
        console.log(error);
        this.deletedSurveys = []
        this.loadingSurveys = false;
      }
    },
    async restoreSurveys() {
      const app = this
      if(this.selected.length){
        try {
          this.restoreInProgress = true;
          await FormsAndSurveyServices.restoreSurveyByIdAndName({ surveys:this.selected.map(survey=>({id:survey._id,name:survey.name})) });
          await new Promise((res)=>{
            setTimeout(()=>{
              app.fetchAllDeletedSurveys();
              this.restoreInProgress = false;
              return res
            },3000)
          })
        } catch (error) {
          console.error(error);
          this.restoreInProgress = false;
        }
      }
    }
  }
});
